import { combineReducers } from "redux";
import { currentUserReducer } from "./data";
import { 
    letterTableFiltersReducer
} from './filter';
import screen from "./screen";

const reducers = combineReducers({
	currentUser: currentUserReducer,
	letterTableFilters: letterTableFiltersReducer,
	screen
});
export default reducers;

export type State = ReturnType<typeof reducers>;
